import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const showTranscribeOnboardingPopoverAtom = atom<boolean>(false);
export const shouldOpenNoteStructureModalOnSessionLoadAtom = atom<boolean>(false);

/**
 * Atom to track if user has seen the post-trial tooltip (shown after trial expires).
 * Persists to localStorage so the tooltip only shows once per user.
 */
export const hasSeenPostTrialTooltipAtom = atomWithStorage(
  'heidi:post-trial-tooltip-seen',
  false
);
